import { Button, Modal } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'

import styles from './index.module.scss'

interface Props {
  couponList: any[]
  visible: boolean
  handleClose: () => void
}

const RegisterCoupon: React.FC<Props> = ({
  couponList,
  visible,
  handleClose
}) => {
  const newUserCoupon = useSelector(
    (state: any) => state.app.newUserCouponPackAmount
  )

  return (
    <Modal
      width={612}
      open={visible}
      title={null}
      onCancel={handleClose}
      footer={null}
      centered={true}
      wrapClassName={styles['register-coupon-modal']}>
      <div className={styles['register-coupon-top']}>
        <i className="iconfont icon-pc-Successful"></i>
        <h5>Registation Successful!</h5>
      </div>
      <div className={styles['register-coupon-tip']}>
        You have earned a <span>{newUserCoupon}</span> coupon bundle which can
        be viewed by adding the item to your cart. The coupon packs are valid
        for 30 days, so we recommend using them as soon as possible. If you have
        any questions, please contact us.
      </div>
      <div className={styles['register-coupon-list']}>
        {Array.isArray(couponList) &&
          couponList.map((item, index) => {
            return (
              <div className={styles['register-coupon-item']} key={index}>
                <div className={styles['register-coupon-item-left']}>
                  <p>{item.couponAmountFormat}</p>
                  OFF
                </div>
                <div className={styles['register-coupon-item-right']}>
                  <p>
                    Code: <span>{item.couponCode}</span>
                  </p>
                  <p className={styles['no-ellipsis']}>
                    Orders Over {item.couponMinimumOrderFormat}
                  </p>
                </div>
              </div>
            )
          })}
      </div>
      <Button
        aria-label="@hernest.com"
        type="primary"
        size="large"
        className={styles['register-gotit']}
        onClick={handleClose}>
        Got It
      </Button>
    </Modal>
  )
}

export default RegisterCoupon
